import { Select as AntSelect } from 'antd';
import { Token } from 'components/common/TokenInput';
import { colours } from 'utils/theme';
import { Icon, Select } from 'components/common';
import { useAuth, useGet } from 'hooks';
import licenseType from 'models/licenseType';
import { useCallback, useMemo } from 'react';
import { allUsersIncludeInactive } from 'services/api';
const { Option } = AntSelect;

const getLicenseIcons = licenses => {
  const hasAcademic = licenses.some(x => licenseType.academic === x.type);
  const hasIndustry = licenses.some(x => licenseType.industry === x.type);
  const hasLegacy = licenses.some(x => licenseType.legacy === x.type);
  return (
    <>
      {hasAcademic && (
        <Icon
          icon='book'
          size='sm'
          style={{ marginRight: '5px' }}
          color='inherit'
        />
      )}
      {hasIndustry && (
        <Icon
          icon='company'
          size='sm'
          style={{ marginRight: '5px' }}
          color='inherit'
        />
      )}
      {hasLegacy && (
        <Icon
          icon='image'
          size='sm'
          style={{ marginRight: '5px' }}
          color='inherit'
        />
      )}
    </>
  );
};

const tagRender = props => {
  const { label, onClose } = props;
  const hasActiveLicense = typeof label !== 'string';
  const onPreventMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Token
      key={label}
      value={label}
      removeToken={onClose}
      style={{ marginTop: '2px', marginBottom: '2px' }}
      onMouseDown={onPreventMouseDown}
      background={
        hasActiveLicense ? colours.inlcudeFilter : colours.excludeFilter
      }
    />
  );
};

export const ShareSelect = ({ sharedWith, setSharedWith }) => {
  const { user } = useAuth();
  const [{ res: allUsersRes, loading: loadingUsers }] = useGet({
    url: allUsersIncludeInactive,
    onMount: true,
  });

  const userOptions = useMemo(() => {
    if (!allUsersRes?.userAccounts) return [];

    return (
      allUsersRes?.userAccounts
        .filter(u => u.active && u.legacyUserId !== user.userId)
        .map(u => ({
          fullname: u.fullname,
          licenses: u.licenses,
          userId: u.legacyUserId,
        }))
        .sort((a, b) => a.fullname.localeCompare(b.fullname)) || []
    );
  }, [allUsersRes, user.userId]);

  const renderUserItem = useCallback((user, idx) => {
    return (
      <Option
        title={user.fullname}
        key={`${user.fullname}-${idx}`}
        value={user.userId}
        data-testid={`$alert-user-option-${idx}`}
        details={user.fullname}
        label={user.fullname}
      >
        {getLicenseIcons(user.licenses)}
        {user.fullname}
      </Option>
    );
  }, []);

  return (
    <div>
      <span style={{ fontSize: 12 }}>Search for People</span>
      <Select
        mode='multiple'
        placeholder='Search for people...'
        value={sharedWith}
        onChange={setSharedWith}
        style={{ width: '100%' }}
        tagRender={tagRender}
        options={userOptions}
        renderOption={renderUserItem}
        loading={loadingUsers}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        notFoundContent={loadingUsers ? 'Loading...' : 'No users found'}
        allowClear
      />
    </div>
  );
};
